import type useCanPurchaseSubscriptionBox from '@context/subscription-box/useCanPurchaseSubscriptionBox'

import { MARKET_ENABLED } from '@lib/constants'
import { isCustomizableBoxVariant } from '@lib/utils/isSubscriptionBox'

import type { UseCanAddToCartParams } from './use-can-add-to-cart'

type GetCanAddToCartParams = {
	product: UseCanAddToCartParams['product']
	variant: UseCanAddToCartParams['variant']
} & Partial<ReturnType<typeof useCanPurchaseSubscriptionBox>>

export default function getCanAddToCart({
	product,
	variant,
	canAddSubscriptionBoxToCart,
	subscriptionBoxInCart,
	alreadyPurchasedSubscriptionBox
}: GetCanAddToCartParams) {
	if (!variant?.id) return false

	const isCustomizableBox = isCustomizableBoxVariant(variant.id)

	// Able to add this subscription box to the cart if it's not already in the cart
	const canAddThisSubscriptionBoxToCart =
		canAddSubscriptionBoxToCart || subscriptionBoxInCart?.productId !== product.id

	const canAddProductToCart =
		(!isCustomizableBox &&
			MARKET_ENABLED &&
			product.availableForSale &&
			variant.availableForSale &&
			(variant.quantityAvailable ?? 1) > 0) || // assume a product is in cart if the `quantityAvailable` is null or undefined
		(isCustomizableBox && canAddThisSubscriptionBoxToCart)

	return Boolean(canAddProductToCart)
}
